import { render, staticRenderFns } from "./CreateChannelModal.vue?vue&type=template&id=2e35778c"
import script from "./CreateChannelModal.vue?vue&type=script&lang=js"
export * from "./CreateChannelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports